/* Vuex module: lightweight UI state (toasts). */
const NS = 'ui'
const t = n => `${NS}/${n}`

export const actionTypes = {
  showToast: t('showToast'),
}

export default {
  namespaced: true,

  state: () => ({
    toast: null, // { type, message }
  }),

  mutations: {
    SET_TOAST(s, v) {
      s.toast = v
    },
  },

  actions: {
    // Resolves so callers can chain navigation after showing a message.
    showToast({ commit }, { type = 'info', message = '' }) {
      commit('SET_TOAST', { type, message, at: Date.now() })
      return Promise.resolve()
    },
  },
}
